import * as React from 'react';
import { Col, Row } from 'reactstrap';
import { Svg } from 'src/components/shared/Svg';
import { IStep } from 'src/model';

interface IProjectPropositionCardFilesProps {
  step: IStep;
}

export const ProjectPropositionCardStep: React.SFC<
  IProjectPropositionCardFilesProps
> = ({ step }) => (
  <Row className='d-flex justify-content-between p-3'>
    <Col
      md='1'
      className='d-flex flex-column align-items-center position-relative'
    >
      <span
        className='step-number text-center text-white mt-1'
        style={{ zIndex: 10 }}
      >
        {step.stepNumber}
      </span>
      <Svg
        className='position-absolute'
        width={48}
        height={48}
        fill='primary'
        src='step-bulle'
      />
    </Col>
    <Col md='2' className='d-flex justify-content-between'>
      <span className='font-weight-bold'>{step.title}</span>
    </Col>
    <Col md='1' className='d-flex justify-content-between'>
      <div className='dot bg-secondary mt-2' />
    </Col>
    <Col md='2'>
      <Svg
        width={20}
        height={20}
        fill='secondary'
        src='start-up'
        style={{ transform: 'rotate(45deg)' }}
      />
      <span className='text-secondary ml-2' style={{ fontSize: '12px' }}>
        {new Date(step.startingDate).toLocaleDateString()}
      </span>
    </Col>
    <Col md='2'>
      <Svg width={20} height={20} fill='primary' src='racing-flag' />
      <span className='text-primary ml-2' style={{ fontSize: '12px' }}>
        {new Date(step.estimatedEndDate).toLocaleDateString()}
      </span>
    </Col>
    <Col md='1' className='d-flex justify-content-between'>
      <div className='dot bg-secondary mt-2' />
    </Col>
    <Col md='3'>
      <span style={{ fontSize: '14px' }}>{step.description}</span>
    </Col>
  </Row>
);



// WEBPACK FOOTER //
// ./src/components/Project/ProjectPropositions/ProjectPropositionCard/ProjectPropositionCardStep.tsx